export function init($name = '') {
    let nav = $($name);

    if (!nav.length) {
        return;
    }

    nav.find('.current-menu-item,.current-menu-ancestor').addClass('is-clicked');

    nav.find('li.menu-item-has-children').click(function(e){
        if (!$(e.target).closest('a').length) {
            e.preventDefault();
            e.stopPropagation();

            $(this).toggleClass('is-clicked');
        }
    });
}